import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import { getAppointmentColor } from 'ziphy-web-shared/basic/entities/appointments';
import { routeActions } from '@config/routeActions';
import { $calendar } from '../../Calendar.store';
import Card from '../Card';
import { useCardMode, usePreparedCardData } from '../Card.hooks';
import styles from './AppointmentCard.module.scss';
const AppointmentCard = ({ date, data }) => {
    var _a;
    const reportAppointment = $calendar.appointments[data.id];
    const cardData = usePreparedCardData({
        date,
        data,
        itemBegin: reportAppointment.appointedStart,
        itemEnd: reportAppointment.appointedFinish,
    });
    const cardMode = useCardMode(cardData);
    const isProgress = ['started'].includes(reportAppointment.status);
    const apptColors = getAppointmentColor({
        status: reportAppointment.status,
        service: {
            providerLoad: reportAppointment.providerLoad,
            agentLoad: reportAppointment.agentLoad,
        },
        patientGroupType: reportAppointment.patientGroupType,
    });
    // function getTitle() {
    //   if (!isProgress || cardMode.mode === 'small') return
    //
    //   return (
    //     <>
    //       {t('label.in_progress')} <Duration from={reportAppointment.factStart} />
    //     </>
    //   )
    // }
    return (_jsx(Card, { ref: cardMode.ref, autoTarget: routeActions.APPT({ appointmentId: data.id }), date: date, data: data, cardData: cardData, colors: {
            bg: apptColors.bg,
            title: apptColors.font.title,
            subtitle: apptColors.font.subtitle,
        }, mode: cardMode.mode, 
        // title={getTitle()}
        subTitle: reportAppointment.service, 
        // showTooltip={cardMode.mode === 'small'}
        showTooltip: true, tooltipAdditional: `(${(_a = $calendar.practices[reportAppointment.practiceId]) === null || _a === void 0 ? void 0 : _a.name})`, className: classNames(styles.wrapper, isProgress && styles.isProgress) }));
};
export default observer(AppointmentCard);
